import { useState } from "react";
import { Template } from "@/lib/types";
import { CreateFromTemplatePreviewAndConfigDialog } from "./CreateFromTemplatePreviewAndConfigDialog";
import { TemplateSelector } from "../template/shared/TemplateSelector";

interface Props {
  onUploadSuccess: () => void;
  onOpenChange: (open: boolean) => void;
}

export const CreateFromTemplateSheet: React.FC<Props> = ({ onUploadSuccess, onOpenChange }) => {
  const [selectedTemplate, setSelectedTemplate] = useState<Template>();

  return (
    <>
      <TemplateSelector onSelectTemplate={setSelectedTemplate} onClose={() => onOpenChange(false)} />
      {selectedTemplate && (
        <CreateFromTemplatePreviewAndConfigDialog
          template={selectedTemplate}
          onClose={() => {
            setSelectedTemplate(undefined);
          }}
          onUploadSuccess={onUploadSuccess}
        />
      )}
    </>
  );
};
